import _u from './utility';
import _v from './vars';

const _fn = {
	
	qCallsPre : [],	
	qCallsPost : [],	
	qCallsPostIdx : 0,	
	qCallsPostPending : false,
	
	qCallsPostWait : function() {
		document.removeEventListener('afterTrackingSent', _fn.qCallsPostWait);
		let qCall = _fn.qCallsPost[_fn.qCallsPostIdx];
		if (qCall.fnName == 'wmdPageLink' || qCall.fnName == 'wmdPageview') {
			_fn.qCallsPostPending = true;
		}
		_fn[qCall.fnName].apply(null, qCall.fnParams);	
		_fn.qCallsPostIdx++;
		_fn.executeQueuePost();
	},
	
	executeQueuePost : function() {
		if (_fn.qCallsPostIdx < _fn.qCallsPost.length) {
			let qCall = _fn.qCallsPost[_fn.qCallsPostIdx];
			if (_fn.qCallsPostPending == true) {
				document.addEventListener('afterTrackingSent', _fn.qCallsPostWait);
			} else {
				if (qCall.fnName == 'wmdPageLink' || qCall.fnName == 'wmdPageview') {
					_fn.qCallsPostPending = true;
				}
				_fn[qCall.fnName].apply(null, qCall.fnParams);	
				_fn.qCallsPostIdx++;
				_fn.executeQueuePost();	
			}
		}
	},
	
	executeQueuePre : function() {
		_fn.qCallsPre.forEach(function(qCall) {
			_fn[qCall.fnName].apply(null, qCall.fnParams);
		});
	},
	
	queueCalls : function(name, params) {
		if (document.readyState != 'loading') {
			if (name == 'wmdSetContext' || name == 'addLinkTrackVars' || name == 'wmdTrack') {
				_fn.qCallsPre.push({
					fnName: name,
					fnParams: params
				});
				document.removeEventListener('beaconInitialized', _fn.executeQueuePre);
				document.addEventListener('beaconInitialized', _fn.executeQueuePre);
			}
			else {
				_fn.qCallsPost.push({
					fnName: name,
					fnParams: params
				});
				document.removeEventListener('afterPageView', _fn.executeQueuePost);
				document.addEventListener('afterPageView', _fn.executeQueuePost);
			}
		}
		else {
			console.log('Error: Call Omniture beacon functions before DOM ready is invalid');
		}
	},

	//add variables passed into module-tracking calls via 'linkTrackVars'
	addLinkTrackVars : function(vars) {
		if (!_v['isInitialized']) {
			_fn.queueCalls('addLinkTrackVars', [vars]);
		}
		else {
			var linkVarTmp = _v.g['s_linkTrackVars'];
			if (typeof vars !== "string" && typeof vars.length !== "undefined") {
				for (var x = 0; x < vars.length; x++) {
					if (vars[x].indexOf('wb.') === 0) {
						linkVarTmp = linkVarTmp + ",contextData." + vars[x];
					}
					else {
						linkVarTmp = linkVarTmp + "," + vars[x];
					}
				}
			}
			else if (typeof vars == "string") {
				if (vars.indexOf('wb.') === 0) {
					linkVarTmp = linkVarTmp + ",contextData." + vars;
				}
				else {
					linkVarTmp = linkVarTmp + "," + vars;
				}
			}
			_v.g['s_linkTrackVars'] = linkVarTmp.replace(/^,/,'');
			s_md.linkTrackVars = _v.g['s_linkTrackVars'];
		}
	},

	//remove variables from module-tracking calls
	remLinkTrackVars : function(vars) {
		if (!_v['isInitialized']) {
			_fn.queueCalls('remLinkTrackVars', [vars]);
		} else {
			var linkVarTmp = _v.g['s_linkTrackVars'];
			var regExTmp;
			if (typeof vars !== "string" && typeof vars.length !== "undefined") {
				for (var x = 0; x < vars.length; x++) {
					if (vars[x].indexOf('wb.') === 0) {
						regExTmp = new RegExp("([ ]+)?contextData\." + vars[x] + "([ ]+)?,?([ ]+)?", "g");
					}
					else {
						regExTmp = new RegExp("([ ]+)?" + vars[x] + "([ ]+)?,?([ ]+)?", "g");
					}
					linkVarTmp = linkVarTmp.replace(regExTmp, '');
				}
			}
			else if (typeof vars == "string") {
				if (vars.indexOf('wb.') === 0) {
					regExTmp = new RegExp("([ ]+)?contextData\." + vars + "([ ]+)?,?([ ]+)?", "g");
				}
				else {
					regExTmp = new RegExp("([ ]+)?" + vars + "([ ]+)?,?([ ]+)?", "g");
				}
				linkVarTmp = linkVarTmp.replace(regExTmp, '');
			}
			_v.g['s_linkTrackVars'] = linkVarTmp.replace(/,$/,'');
			s_md.linkTrackVars = _v.g['s_linkTrackVars'];
		}
	},

	//sets context data variables after beacon is loaded that will be sent to omniture
	wmdSetContext : function(key, value) {
		if (!_v['isInitialized']) {
			_fn.queueCalls('wmdSetContext', [key, value]);
		} else {
			if (key) {
				if (typeof key !== 'string' && Object.keys(key).length > 0) {
					Object.keys(key).forEach(function(x) {
						var currVal = String(key[x]).toLowerCase();
						var currKey = x.replace(/[^A-Za-z0-9\.]/g, "").toLowerCase();
						if (_v.removeQuoteIn.indexOf(currKey) != -1) {
							currVal = currVal.replace(/'/g,'');
						}
						s_md.contextData[currKey] = currVal;
					});
				} else {
					key = key.toString().replace(/[^A-Za-z0-9\.]/g, "").toLowerCase();
					//pulsepoint genome - tpi value needs to not be lowercased
					if (_v.lowerCaseOvrRide.indexOf(key) !=-1) {
						value = String(value);
					}
					else {
						value = String(value).toLowerCase();
					}
					if (_v.removeQuoteIn.indexOf(key) != -1) {
						value = value.replace(/'/g,'');
					}
					s_md.contextData[key] = value;
				}
			}
		}
	},

	//removes variables from context data
	wmdRemContext : function(key) {
		if (!_v['isInitialized']) {
			_fn.queueCalls('wmdRemContext', [key]);
		} else {
			if (key) {
				if (typeof key !== "string" && typeof key.length !== "undefined") {
					for (var x = 0; x < key.length; x++) {
						delete s_md.contextData[key[x].replace(/[^A-Za-z0-9\.]/g, "").toLowerCase()];
					}		
				} else {
					key = key.replace(/[^A-Za-z0-9\.]/g, "").toLowerCase();
					delete s_md.contextData[key];
				}
			}
		}
	},

	pushContextClr : function(key) {
		if (key) {
			if (typeof key !== "string" && typeof key.length !== "undefined") {
				for (var x = 0; x < key.length; x++) {
					_v['contextClrArr'].push(key[x]);
				}		
			} else {
				_v['contextClrArr'].push(key);
			}
		}
	},

	contextClr : function() {
		for (var x = 0; x < _v['contextClrArr'].length; x++) {
			delete s_md.contextData[_v['contextClrArr'][x]];
		}
		_v['contextClrArr'] = [];
	},
	
	tCb : function() {
		_fn.contextClr();
		_fn.qCallsPostPending = false;
		document.dispatchEvent(new CustomEvent('afterTrackingSent'));
		if (!_v['firstPvDone']) { // On first run, send 'afterPageView' event for pageview callback
			_v['firstPvDone'] = true;
			window.firstPvDone = _v['firstPvDone'];
			document.dispatchEvent(new CustomEvent('afterPageView'));
		}
	},

	//Hybrid of Module / Page View tracking – this sets an optional ‘module value’ (same as used with ‘wmdPageLink’) on a subsequent page view call.
	// This method is preferable for all same-domain internal site links where module tracking is desired, as it fires only one Omniture call.
	wmdTrack : function(sSource, domElem) {
		if (!_v['isInitialized']) {
			_fn.queueCalls('wmdTrack', [sSource, domElem]);
		} else {
			if (typeof this !== "undefined" && this !== null && typeof this.innerHTML != "undefined") {
				_fn.ctrs(sSource, this);
			}
			else {
				_fn.ctrs(sSource, domElem);
			}
		}
	},

	ctrs : function(sSource, domElem) {
		_v.chkOnEachTrackCall.forEach(function(d) {
			_fn.scanCtxVars(d);
		});
		var modVal = sSource.split('_');
		if (modVal.length < 2) {
			modVal.push('');
		}	
		_v.modVarPass = {
			'wb.mmodule': modVal[0].toLowerCase(),
			'wb.mlink': modVal[1].toLowerCase(),
			'wb.mpage': s_md.pageName.split("_").join("-").toLowerCase()
		};	
		for (var x = 0; x < _v.referVals.length; x++) {
			if (typeof s_md.contextData[_v.referVals[x]] != "undefined" && s_md.contextData[_v.referVals[x]] != '') {
				_v.modVarPass[_v.referVals[x].replace('.','.m')] = s_md.contextData[_v.referVals[x]];
			}
		}
		if (typeof domElem != "undefined" && domElem != null && typeof domElem.innerHTML != "undefined" && domElem.innerHTML != '') {
			_v.modVarPass['wb.lnktxt'] = domElem.innerHTML.replace(/<[^>]+>/g,"").replace(/&\S+\;/g,'').replace(/[^\w\s]/g, '').replace(/\s+/g,' ').toLowerCase().trim();		
			for (var x = 0; x < domElem.attributes.length; x++) {
				if (domElem.attributes[x].name.indexOf('data-wb-') == 0 && domElem.attributes[x].name.split('wb-')[1] != '' && domElem.attributes[x].value != '') {			
					_v.modVarPass['wb.' + domElem.attributes[x].name.split('wb-')[1].replace(/[^A-Za-z0-9\.]/g, "").toLowerCase()] = domElem.attributes[x].value.toLowerCase();
				}
			}
		} else if (typeof domElem != "undefined" && ((domElem != null && typeof domElem.innerHTML == "undefined") || domElem == null)) {
			console.log('Error in "wmdTrack" 2nd function parameter: ' + typeof domElem + ' - ' + domElem + '. Function expects a single HTMLElement.');
		}
		if (typeof domElem != "undefined" && domElem != null && typeof domElem.href != "undefined" && domElem.href.indexOf('javascript:') == -1) {
			var cLink = _u.urlClean(domElem.href).replace(/\S+px\/tr\S+\exturl=/,'');
			if (cLink.match(_v.intSiteRegEx) != null || cLink.match(/(^\/[^\/])|(^\/$)/) != null) {
				_v.modVarPass['wb.cstm'] = 'landpg::' + cLink;
			}
		}
		var _dt = new Date();
		var dExpiry = new Date(_dt.getFullYear(), _dt.getMonth(), _dt.getDate(), _dt.getHours(), _dt.getMinutes(), _dt.getSeconds() + 20);
		document.cookie = "modvpass=" + encodeURIComponent(JSON.stringify(_v.modVarPass)) + "; path=/; domain=" + _v.s_domain + ";expires=" + dExpiry.toGMTString();
	},

	//For Custom Link/Module Tracking
	wmdPageLink : function(link, domElem) {	
		if (!_v['isInitialized']) {
			_fn.queueCalls('wmdPageLink', [link, domElem]);
		} else {
			let isA2A = false;
			if (typeof mscpA2A !== "undefined" && mscpA2A === true) {
				const url = domElem ? domElem.closest('.inf-art-wrap').getAttribute('data-contenturl'): '';
				if (url && url !== '' && window.location.href.indexOf(url) === -1) {
					window.PageMetadata = infMetaRespObj[url]
					window.DFPTargetKeys = PageMetadata;
					scanOmniVars(true);
					s_md.pageURL = infSmdObj[url].pageURL;
					s_md.pageName = _u.urlClean(url);
					s_md.contextData['wb.pgtitle'] = infPgTitleObj[url].toLowerCase();
					s_md.contextData['wb.asset'] = infSmdObj[url].contextData['wb.asset'];
					s_pageview_id = infSmdObj[url].contextData['wb.pvid'];
					isA2A = true;
				}	
			}
			_v.chkOnEachTrackCall.forEach(function(d) {
				_fn.scanCtxVars(d);
			});
			for (var x = 0; x < _v.referVals.length; x++) {
				if (typeof s_md.contextData[_v.referVals[x]] !== "undefined" && s_md.contextData[_v.referVals[x]] != '') {
					_fn.wmdSetContext(_v.referVals[x].replace('.','.m'), s_md.contextData[_v.referVals[x]]);
				}
			}
			var linkSpl = link.toLowerCase().split('_');
			if (typeof linkSpl[1] != 'undefined') {
				_fn.wmdSetContext({'wb.mmodule': linkSpl[0], 'wb.mlink': linkSpl[1], 'wb.mpage': s_md.pageName.split("_").join("-")});
			} else {
				_fn.wmdSetContext({'wb.mmodule': linkSpl[0], 'wb.mpage': s_md.pageName.split("_").join("-")});
			}
			if (typeof this !== "undefined" && this != null && typeof this.innerHTML !== "undefined" && typeof domElem == "undefined") {
				domElem = this;
			}			
			if (typeof domElem !== "undefined" && domElem !== null && typeof domElem.innerHTML !== "undefined") {
				s_md.contextData['wb.lnktxt'] = domElem.innerHTML.replace(/<[^>]+>/g,"").replace(/&\S+\;/g,'').replace(/[^\w\s]/g, '').replace(/\s+/g,' ').toLowerCase();
				if (typeof domElem.href != "undefined" && domElem.href.indexOf('javascript:') == -1) {
					var cLink = _u.urlClean(domElem.href).replace(/\S+px\/tr\S+\exturl=/,'');
					if (/(pptx?$)|(exe$)|(zip$)|(wav$)|(mp3$)|(mov$)|(mpg$)|(avi$)|(wmv$)|(mp4$)|(docx?$)|(pdf$)|(xlsx?$)/i.test(cLink)) {
						_fn.wmdSetContext('wb.dwnld', 'dwnld::' + cLink);
					} else if (cLink.match(_v.intSiteRegEx) != null || cLink.match(/(^\/[^\/])|(^\/$)/) != null) {
						_fn.wmdSetContext('wb.cstm', 'landpg::' + cLink);
					} else {
						_fn.wmdSetContext('wb.exiturl', 'exit::' + cLink);
					}
				}
				var elemData = [];
				for (var x = 0; x < domElem.attributes.length; x++) {
					if (domElem.attributes[x].name.indexOf('data-wb-') == 0 && domElem.attributes[x].name.split('wb-')[1] != '' && domElem.attributes[x].value != '') {
						_fn.wmdSetContext('wb.' + domElem.attributes[x].name.split('wb-')[1], domElem.attributes[x].value);
						elemData.push('wb.' + domElem.attributes[x].name.split('wb-')[1]);
						s_md.linkTrackVars = s_md.linkTrackVars + ',' + 'contextData.wb.' + domElem.attributes[x].name.split('wb-')[1].replace(/[^A-Za-z0-9\.]/g, "").toLowerCase();
					}
				}
			} else if (typeof domElem !== "undefined") {
				console.log('Error in "wmdPageLink" 2nd function parameter: ' + typeof domElem + ' - ' + domElem + '. Function expects a single HTMLElement.');
			}

			link = s_md.pageName.split("_").join("-") + "_" + link;
			try {
				if (document.getElementById('mscp-gtm') != null) {
					gtag('event', 'click', _fn.formatVarsForGoogle(true));
				}
			} catch(e) { }
			void(s_md.tl(true, 'o', link.toLowerCase()));

			_fn.wmdRemContext(['wb.lnktxt','wb.mmodule','wb.mlink','wb.mpage','wb.exiturl','wb.dwnld','wb.cstm']);
			for (var x = 0; x < _v.referVals.length; x++) {
				_fn.wmdRemContext(_v.referVals[x].replace('.','.m'));
			}	
			_fn.wmdRemContext(elemData);
			s_md.linkTrackVars = _v.g['s_linkTrackVars'];
			
			if (isA2A) {
				window.PageMetadata = infMetaRespObj[currSlctCont];
				scanOmniVars(true);
			}
		}
	},

	//sent on page load or when over 50% of the content on a page changes (e.g. virtual page implementations)
	//sent by default by any page which contains the beacon code in the site footer
	wmdPageview : function(sPageName, iCount, noAdRefresh) {
		if (!_v['isInitialized']) {
			_fn.queueCalls('wmdPageview', [sPageName, iCount]);
		} else {
			_fn.wmdSetContext("wb.pagination", iCount);
			try {
				sPageName = _u.urlClean(sPageName);
			} catch (e) {}
			if (sPageName !== "") {
				s_md.pageName = sPageName;
			}
			if (Object.keys(_v.modVarPass).length > 0 && typeof _v.modVarPass['wb.mmodule'] == 'string' && _v.modVarPass['wb.mmodule'] != '') {
				var _dtDel = new Date();
				document.cookie = "modvpass=undefined; path=/; domain=" + _v.s_domain + ";expires=" + _dtDel.toGMTString();
				_fn.wmdSetContext(_v.modVarPass);
				_fn.pushContextClr(Object.keys(_v.modVarPass));
				_v.modVarPass = {};
			}
			if (!_v.defaultPV && _v['s_ver'].indexOf('prof') != -1) { // If 'prof' beacon and not the default pageview call, regenerate PVID
				_u.GenPVID(noAdRefresh);
			}
			_v.chkOnEachTrackCall.forEach(function(d) {
				_fn.scanCtxVars(d);
			});
			try {
				if (document.getElementById('mscp-gtm') != null) {
					gtag('event', 'page_view', _fn.formatVarsForGoogle());
				}
			} catch(e) { }
			void(s_md.t());
			return new Promise(function(resolve, reject) {
				resolve(window.s_pageview_id);
			});
		}
	},
	
	//sent variables to Google calls, check "s_md.contextData" key exist in "s_md.linkTrackVars"
	formatVarsForGoogle : function(isClick) { 
		let googleTrackingVar = {'send_to': 'G-FZV5XMCPSP'};
		let userVar = {};
		if (typeof isClick == "boolean" && isClick) {
			let tempLinkTrackVars = s_md.linkTrackVars.replaceAll(/contextData./g, "").split(',');	
			Object.keys(s_md.contextData).forEach(function(d) {
				if(tempLinkTrackVars.includes(d)) {
					const newKey = d.replace(/wb./,'');
					if (_v.userMetaKeys.indexOf(d) != -1) {
						userVar[newKey] = s_md.contextData[d];
					}
					googleTrackingVar[newKey] = s_md.contextData[d];
				}
			});	
		}
		else {
			Object.keys(s_md.contextData).forEach(function(d) {
				const newKey = d.replace(/wb./,'');
				if (_v.userMetaKeys.indexOf(d) != -1) {
					userVar[newKey] = s_md.contextData[d];
				}
				googleTrackingVar[newKey] = s_md.contextData[d];
			});
		}
		googleTrackingVar['pageName'] = s_md.pageName;
		googleTrackingVar['userId'] = s_md.contextData['wb.regid'];
		if (Object.keys(userVar).length > 0) {
			googleTrackingVar['user_properties'] = userVar;
		}
		return googleTrackingVar;
	},
	//check if the PageMeta Target Key exists
	chkPageMetaKey : function(metaGrp, metaKey) {
		if (typeof PageMetadata[metaGrp] !== "undefined" && typeof PageMetadata[metaGrp][metaKey] !== "undefined" && PageMetadata[metaGrp][metaKey] !== null && Number(PageMetadata[metaGrp][metaKey]) !== 0) {
			return true;
		} 
		else if (typeof PageMetadata[metaGrp] !== "undefined" && typeof PageMetadata[metaGrp][metaKey] !== "undefined" && PageMetadata[metaGrp][metaKey] !== null && _v.allowZero.indexOf(metaKey) !==-1) {
			return true;
		}		
		else {
			return false;
		}
		
	},

	//set context data from PageMeta Target Keys
	scanMetaDataKeys : function() {
		if (typeof PageMetadata !== "undefined") {
			Object.keys(_v.pageMetaKeyMap).forEach(function(key) {
				if (_v.pageMetaKeyMap[key].split('.').length == 2) {
					var metaGrp = _v.pageMetaKeyMap[key].split('.')[0];
					var metaKey = _v.pageMetaKeyMap[key].split('.')[1];				
					if (_fn.chkPageMetaKey(metaGrp, metaKey)) {
						if (key == 'wb.ldcncptid') {
							_fn.wmdSetContext(key, PageMetadata[metaGrp][metaKey].toString() + 'p');
						}
						else if (key == 'wb.authchn') {
							_fn.wmdSetContext(key, PageMetadata[metaGrp][metaKey].toString() + '-' + PageMetadata['authVar']['authLevel']);
						}
						else if ((key == 'wb.respon' || key == 'wb.interest') && PageMetadata[metaGrp][metaKey].toString().match(/\[(.+)?\]/) != null) {
							_fn.wmdSetContext(key, JSON.parse(PageMetadata[metaGrp][metaKey].toString()).join('|'));
						}
						else {
							_fn.wmdSetContext(key, PageMetadata[metaGrp][metaKey]);
						}
					}				
				}			
			});
		}
	},

	//set context data from context page variables
	scanCtxVars : function(ctxVar) {
		if (typeof ctxVar !== 'undefined') {
			if (Object.keys(_v.ctxVarMap).indexOf(ctxVar) !== -1) {
				if (typeof window[_v.ctxVarMap[ctxVar]] !== 'undefined') { // Check Global Scope
					_fn.wmdSetContext(ctxVar, window[_v.ctxVarMap[ctxVar]]);	
				} else if (typeof _v[_v.ctxVarMap[ctxVar]] !== 'undefined') { // Else Check Module Vars
					_fn.wmdSetContext(ctxVar, _v[_v.ctxVarMap[ctxVar]]);
				} else if (Object.keys(_v.ctxVarMap).indexOf(ctxVar + '_default') !== -1 && typeof s_md.contextData[ctxVar] === 'undefined') { // Else Check for Default
					_fn.wmdSetContext(ctxVar, _v.ctxVarMap[d + '_default']);
				}
			}
		} else {						
			Object.keys(_v.ctxVarMap).forEach(function(d) {							
				if (d.indexOf('_default') == -1) {					
					if (typeof window[_v.ctxVarMap[d]] !== 'undefined') { // Check Global Scope
						_fn.wmdSetContext(d, window[_v.ctxVarMap[d]]);	
					} else if (typeof _v[_v.ctxVarMap[d]] !== 'undefined') { // Else Check Module Vars
						_fn.wmdSetContext(d, _v[_v.ctxVarMap[d]]);
					} else if (Object.keys(_v.ctxVarMap).indexOf(d + '_default') !== -1 && typeof s_md.contextData[d] === 'undefined') { // Else Check for Default
						_fn.wmdSetContext(d, _v.ctxVarMap[d + '_default']);
					}
				}
			});
		}
	},
	
	getLoadTime : function () {
		if (typeof window.s_loadT == 'undefined') {
			var b = new Date().getTime(),
				o = window.performance ? performance.timing : 0,
				a = o ? o.requestStart : window.inHeadTS || 0;

			var s_loadT = a ? Math.round((b - a) / 100) : '';

			if (s_loadT < 0 || s_loadT > 3000) {
				s_loadT = '';
			}
		}
		return s_loadT;
	},
	
	createPageState : function() {	
		if (typeof _v.g['s_page_state'] === 'undefined') {
			_v.g['s_page_state'] = '';
		}
		try {
			for (var x = 0; x < document.querySelectorAll("[data-metric-dynamic]").length; x++) {
				_v.g['s_page_state'] += '|' + document.querySelectorAll("[data-metric-dynamic]")[x].getAttribute('data-metric-dynamic').replace(/^\s+/g, '').replace(/\s+$/g,'');
			}
		} catch(e) { }
		_v.g['s_page_state'] = _v.g['s_page_state'].replace(/^\|/,'');
		if (_v.g['s_page_state'] !== '') {
			_fn.wmdSetContext('wb.modimp', _v.g['s_page_state']);
			_v.g['s_page_state'] = '';
		}
	},
	
	rescanGlobals : function() {
		s_md.contextData = {};
		_v.globVar.forEach(function(e, i) {  // Check for presence of Global overrides
			if (typeof window[e] !== 'undefined') {
				_v.g[e] = window[e];
			}
		});
		if (typeof _v.g['s_linkTrackExtend'] === "string") {
			_v.g['s_linkTrackExtend'] = _v.g['s_linkTrackExtend'].replace(/(contextData\.)?wb\./g,'contextData.wb.');
			_v.g['s_linkTrackVars'] = String(_v.g['s_linkTrackVars'] + ',' + _v.g['s_linkTrackExtend']).replace(/^,/,'');
		}
		if (typeof window.s_pagename == 'undefined') {
			_v.g['s_pagename'] = _u.urlClean(window.location.protocol + '//' + window.location.hostname + window.location.pathname);
		} else if (typeof window.s_pagename == 'string') {
			_v.g['s_pagename'] = _u.urlClean(window.s_pagename);
		}
		s_md.pageName = _u.urlClean(_v.g['s_pagename']);
		if (typeof window.s_pageurl != 'string') {
			_v.g['s_pageurl'] = window.location.href;
		} else {
			_v.g['s_pageurl'] = window.s_pageurl;
		}
		s_md.pageURL = _v.g['s_pageurl'];
	},

	getAuthLevel : function(authChannel) {
		var authLevel = "";
		if (typeof authChannel.split('-')[1] !== 'undefined') {
			authLevel = authChannel.split('-')[1];
		}
		else {
			if (authChannel === '100') {
				authLevel = '0';
			}
			else if (authChannel === '103' || authChannel === '104' || authChannel === '105' || authChannel === '107' || authChannel === '108') {
				authLevel = '2';
			}
			else {
				authLevel = '1';
			}
		}
		return authLevel;
	}

}

_v['globFunc'].forEach(function(e) {  // Expose global functions to window
	window[e] = _fn[e];
});

export default _fn;